module.exports = __webpack_public_path__ + "static/toasted-siopao-d993bedecd69df24c8d329386308e4ce.jpg";